function _(e) {
  const s = e.regex, a = {
    className: "number",
    relevance: 0,
    variants: [
      { begin: /([+-]+)?[\d]+_[\d_]+/ },
      { begin: e.NUMBER_RE }
    ]
  }, n = e.COMMENT();
  n.variants = [
    {
      begin: /;/,
      end: /$/
    },
    {
      begin: /#/,
      end: /$/
    }
  ];
  const t = {
    className: "variable",
    variants: [
      { begin: /\$[\w\d"][\w\d_]*/ },
      { begin: /\$\{(.*?)\}/ }
    ]
  }, i = {
    className: "literal",
    begin: /\bon|off|true|false|yes|no\b/
  }, c = {
    className: "string",
    contains: [e.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: "'''",
        end: "'''",
        relevance: 10
      },
      {
        begin: '"""',
        end: '"""',
        relevance: 10
      },
      {
        begin: '"',
        end: '"'
      },
      {
        begin: "'",
        end: "'"
      }
    ]
  }, r = {
    begin: /\[/,
    end: /\]/,
    contains: [
      n,
      i,
      t,
      c,
      a,
      "self"
    ],
    relevance: 0
  }, E = /[A-Za-z0-9_-]+/, l = /"(\\"|[^"])*"/, b = /'[^']*'/, o = s.either(
    E,
    l,
    b
  ), g = s.concat(
    o,
    "(\\s*\\.\\s*",
    o,
    ")*",
    s.lookahead(/\s*=\s*[^#\s]/)
  );
  return {
    name: "TOML, also INI",
    aliases: ["toml"],
    case_insensitive: !0,
    illegal: /\S/,
    contains: [
      n,
      {
        className: "section",
        begin: /\[+/,
        end: /\]+/
      },
      {
        begin: g,
        className: "attr",
        starts: {
          end: /$/,
          contains: [
            n,
            r,
            i,
            t,
            c,
            a
          ]
        }
      }
    ]
  };
}
export {
  _ as default
};
